import Keycloak from "keycloak-js";

const baseUrl = window.location.origin;
const index = baseUrl.indexOf(".");
// const url = index === -1 ? "https://dq1q8kbn60m09.cloudfront.net" : baseUrl;
// const url = index === -1 ? "https://uat-pmg.dpiit.gov.in" : baseUrl;
const url = index === -1 ? "http://pmiic.test" : baseUrl;
// const url = index === -1 ? "http://qa-pmg.dpiit.gov.in" : baseUrl;
// const url = index === -1 ? "https://d2yfyl2y8syon1.cloudfront.net" : baseUrl;
//const url = index === -1 ? "https://d1br15z8tgl8tn.cloudfront.net/login" : baseUrl;
const apiNetworkInterface = {
  development: url,
  staging: "",
  qa: "",
  mock: "d2yfyl2y8syon1.cloudfront.net"
};

const PMIIC = {
  API_ROOT:
    apiNetworkInterface[process.env.REACT_APP_ENV] ||
    apiNetworkInterface.development,
  resultDto(statusCode, message, result) {
    return {
      statusCode,
      message,
      result
    };
  },
  getApiUrlFromRoot(url) {
    return this.API_ROOT + url;
  },
  getMockUrl(url) {
    return apiNetworkInterface.mock + url;
  },
  getHeaders(headers) {
    const HEADERS = {
      JSON: {
        "Content-Type": "application/json",
        "Cache-control": "no-cache",
        //"Cache-control": "no-store",
        //"Cache-control": "pre-check=0",
        //"Cache-control": "post-check=0",
        //"Cache-control": "must-revalidate",
        //Pragma: "no-cache",
        "Access-Control-Allow-Origin": "*"
      },
      URL_ENCODED: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      MULTIPART_FORM_DATA: {
        "Content-Type": "multipart/form-data"
      },
      TEXT_HTML: {
        "Content-Type": "text/html"
      },
      OCTET_STREAM: {
        "Content-Type": "application/octet-stream"
      },
      XML: {
        "Content-Type": "application/json, text/plain, */*"
      }
    };
    function getHeaders() {
      let headerObj = [];
      headers.forEach(item => {
        const header = HEADERS[item];
        headerObj = Object.assign(headerObj, header);
      });
      return headerObj;
    }
    return getHeaders();
  }
};

export const iigBaseUrl =
  baseUrl === "https://dev-pmg.dpiit.gov.in"
    ? "https://iigdev.uatnegd.online"
    : baseUrl === "https://uat-pmg.dpiit.gov.in"
    ? "https://iigdev.uatnegd.online"
    : baseUrl === "https://ppe-pmg.dpiit.gov.in"
    ? "https://iigdev.uatnegd.online"
    : "https://paimana-crip.mospi.gov.in";

export const keycloak = new Keycloak({
  realm: "master",
  url:
    baseUrl === "https://dev-pmg.dpiit.gov.in"
      ? "https://uatsso.indiainvestmentgrid.com/"
      : baseUrl === "https://uat-pmg.dpiit.gov.in"
      ? "https://ppesso.indiainvestmentgrid.com/"
      : baseUrl === "https://ppe-pmg.dpiit.gov.in"
      ? "https://ppesso.indiainvestmentgrid.com/"
      : baseUrl === "https://pmg.dpiit.gov.in"
      ? "https://sso.indiainvestmentgrid.com/"
      : "http://localhost:8080/",
  clientId: "pmgkeycloak",
  "ssl-required": "external"
});

export default PMIIC;
